module.exports = __webpack_public_path__ + "img/geod_15.ab7295fd.jpg";